import { Edit, Delete } from "@mui/icons-material";
import React from "react";
import { Tooltip, IconButton, Typography } from "@mui/material";
import { setDefaultDataSupplier, setSupplierId } from "store/modules/Suppliers";
import { v4 as uuidv4 } from 'uuid';


export const columns = (setOpen, setMode,setOpenDelete, dispatch) => {
  return [{
    field: `${uuidv4()}`,
    headerName: "Acciones",
    width: 100,
    renderCell: (data) => (
      <React.Fragment>
        <Tooltip title="Editar Proveedor" placement="top">
          <IconButton
            aria-label="edit"
            color="primary"
            onClick={() => { setOpen(true); setMode("PUT"); dispatch(setDefaultDataSupplier(data.row));dispatch(setSupplierId(data.row.id)) }}
          >
            <Edit />
          </IconButton>
        </Tooltip>
        <Tooltip title="Eliminar Proveedor" placement="top">
          <IconButton
            aria-label="delete"
            color="primary"
            onClick={() => { setOpenDelete(true); setMode("DELETE");dispatch(setSupplierId(data.row.id)) }}
          >
            <Delete />
          </IconButton>
        </Tooltip>

      </React.Fragment>
    ),
  },
  {
    field: "code",
    headerName: "Código",
    width: 200,
  },
  {
    field: "phone",
    headerName: "Telefono",
    width: 200,
  },
  {
    field: "nombre",
    headerName: "Nombre",
    width: 250,
    renderCell: (data) => (
      <Typography>{`${data.row.persona.nombre} ${data.row.persona.apellidoPaterno} ${data.row.persona.apellidoMaterno} `} </Typography>
  )
  },
  {
    field: "rfc",
    headerName: "RFC",
    width: 250,
    renderCell: (data) => (
      <Typography>{`${data.row.persona.rfc}`} </Typography>
  )
  },
  {
    field: 'direccion',
    headerName: "Dirección",
    width: 350,
    renderCell: (data) => (
      <Typography>{`${data.row.persona.direccion}`} </Typography>
  )
  },
  
]
}
